module.exports = __webpack_public_path__ + "static/media/hyperactive.4096da28.svg";